import { message } from "antd";
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "../axios";

export const getSetupCost = async (payload) => {
  try {
    const res = await axiosGet({
      path: `payment/setup-cost?discount=${payload?.value?.discount}`,
    });
    return res;
  } catch (error) {
    message.error(error.response.data.message);
  }
};
export const getCardList = async () => {
  try {
    const bId = localStorage.getItem("businessId")
    const uId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: `payment/list-card?userId=${uId}&businessId=${bId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const billingAddress = async (payload) => {
  try {
    const res = await axiosPost({
      path: "payment/initiate-subscription",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error.response.data.message);
  }
};

export const updateBusiness = async (payload) => {
  try {
    const res = await axiosPatch({
      path: "business",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const deletePaymentCard = async (id) => {
  try {
    const res = await axiosDelete({
      path: `payment/delete-payment-method/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error.response.data.message);
  }
};
export const updatePaymentCard = async (id) => {
  try {
    const res = await axiosPatch({
      path: `payment/update-primary-card/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error.response.data.message);
  }
};
export const addPaymentCard = async (payload) => {
  try {
    const res = await axiosPost({
      path: "payment/add-card",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error.response.data.message);
  }
};
